module.exports = __webpack_public_path__ + "static/media/questionActive.6b0e4e52.svg";